define(
    'models/admin_menu_link.model',[
        'loader',
        'config',
        'helper',
        'sandbox'
    ],
    function (
        Loader,
        Config,
        Helper,
        Sandbox
        )
    {
        var _ = Loader._;

        var AdminMenuLinkModel = Loader.Backbone.Model.extend({

            defaults: {
                title:      '',
                submenu:    [],
                href:       '',
                indicator:  null,
                className:  "item",
                position:   null,
                isActive:   false
            },

            initialize: function()
            {
                var _this = this;
                this.model = this.get('model');
            }

        });

        return AdminMenuLinkModel;
    }
);

